import {Presenter} from '../../../../Support/with_presenter';
import {FullWorkout} from '../../../../Models/FullWorkout';
import {WorkoutsService} from '../../../../Network/WorkoutsService';

export class UploadToStravaPresenter implements Presenter {
    public uploading = false;
    public syncedToStrava: boolean;

    constructor(private fullWorkout: FullWorkout, private workoutService: WorkoutsService) {
        this.syncedToStrava = fullWorkout.strava_synced;
    }

    public mount(): void {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }

    public async uploadToStrava(): Promise<void> {
        try {
            this.uploading = true;
            await this.workoutService.uploadToStrava(this.fullWorkout.id);
            // Wait a second to give the user a chance to see the loading indicator
            // There is no error handling since the Strava upload is happening on a background queue
            await new Promise((resolve) => setTimeout(resolve, 1000));
            this.syncedToStrava = true;
        } finally {
            this.uploading = false;
        }
    }
}
